import React from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  className?: string;
  width?: string;
  height?: string;
};

const Plus: React.FC<Props> = ({ className, fill = 'none', stroke = '#0B1215', width = '24', height = '24' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill={fill} stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
);

export default Plus;
